import {HttpClient} from '@angular/common/http'
import {inject, Injectable} from '@angular/core'
import {Observable} from 'rxjs'
import {environment} from '../../environments/environment'

export interface IMessage {
  messageId: string
  senderName: string
  timeStamp: number
  content: string
  messageRead: number
}

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  protected http = inject(HttpClient)

  public getMessages(): Observable<IMessage[]> {
    const url = `${environment.meetingPlannerApi}/user`
    return this.http.get<IMessage[]>(url)
  }

  public getMessage(messageId: string): Observable<IMessage> {
    const url = `${environment.meetingPlannerApi}/user/${messageId}`
    return this.http.get<IMessage>(url)
  }
}
